import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

const BATCH_UPLOAD_ENABLED_PATH =
  '/api/assessments/candidate-assessments/batches/upload-enabled';

/**
 * Reads whether the assessment batch data upload section is enabled.
 * Defaults to enabled while loading or when the flag cannot be read, so the
 * UI never hides a feature for admins because of a transient request failure.
 */
export function useBatchUploadEnabled(options?: { enabled?: boolean }) {
  const query = useQuery({
    queryKey: ['feature-flag', 'assessment-batch-upload'],
    queryFn: () =>
      apiRequest<{ enabled: boolean }>(BATCH_UPLOAD_ENABLED_PATH).catch(() => ({
        enabled: true,
      })),
    enabled: options?.enabled ?? true,
    staleTime: 60_000,
  });

  return {
    isEnabled: query.data?.enabled ?? true,
    isLoading: query.isLoading,
    query,
  };
}
